import fetch from 'isomorphic-fetch';

export const SUBMIT_INVITATION = 'SUBMIT_INVITATION';
export const RESET_INVITATION_FORM = 'RESET_INVITATION_FORM';

function submitInvitation(status) {
  return {
    type: 'SUBMIT_INVITATION',
    status,
  };
}

export function resetInvitationForm() {
  return {
    type: 'RESET_INVITATION_FORM',
  };
}

export function sendInvitation({ email, message }) {
  return (dispatch, getState) =>
    new Promise((resolve, reject) => {
      dispatch(submitInvitation('submitting'));
      const token = getState().users.token;

      fetch(`${__API_HOST__}/api/v1.1/users/invite`, {
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        method: 'post',
        body: JSON.stringify({
          email,
          message,
        }),
      })
        .then(response => response.status)
        .then(status => {
          if (status === 200) {
            dispatch(submitInvitation('success'));
          } else {
            dispatch(submitInvitation('failure'));
          }
        })
        .catch(ex => reject(ex));
    });
}



// WEBPACK FOOTER //
// ./app/actions/InviteActionCreator.js